import { createCookie, readCookie, getPortalCD } from "./helpers";
import { getDashboardPathByAbTest } from "./utility-functions";
import { DASHBOARD_AB_TEST_ID } from "./general-config";
import FunnelStepTypes from "../pages/funnel-step/types";

/**
 * Fetches AB test and navigates to appropriate dashboard
 * @param {Object} params - Parameters object
 * @param {string} params.userGuid - The user GUID
 * @param {Function} params.fetchAbTestConnect - The AB test fetch function
 * @param {Function} params.navigate - The navigation function
 * @param {string} params.currentLocale - The current locale
 * @returns {Promise<void>}
 */
const PushDashboardAbTestValueFunnelStep = (dashboardAbTestValue) => {
  return {
    type: FunnelStepTypes.SET_DASHBOARD_AB_TEST_VALUE,
    dashboardAbTestValue,
  };
};

export const fetchABTestAndNavigate = async ({
  userGuid,
  fetchAbTestConnect,
  navigate,
  currentLocale,
  dispatch,
}) => {
  try {
    const res = await fetchAbTestConnect({
      abtestId: DASHBOARD_AB_TEST_ID,
      userGuid,
    });
    const caseValue = res?.abTestVariant ?? null;
    dispatch(PushDashboardAbTestValueFunnelStep(caseValue));
    // createCookie("dashboardAbTestValue", caseValue, 1);
    const dashboardPath = getDashboardPathByAbTest(caseValue, currentLocale);
    navigate(dashboardPath);
  } catch (error) {
    console.error("Error fetching AB test:", error);
    // Fallback to default dashboard path if needed
    // navigate(dashboardPath);
  }
};
